import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CART_URL } from "./salesData";
type CTAButtonProps = {
  children: React.ReactNode;
  size?: "md" | "lg";
  className?: string;
};
export function CTAButton({
  children,
  size = "md",
  className = ""
}: CTAButtonProps) {
  const sizing = size === "lg" ? "px-8 py-5 text-lg sm:text-2xl" : "px-7 py-4 text-base sm:text-xl";
  return <a href={CART_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-xl bg-[#f5a623] font-extrabold uppercase tracking-wide text-[#0d1b3e] shadow-[0_10px_0_0_#c47f10] transition-all duration-150 hover:-translate-y-0.5 hover:bg-[#ffb52e] hover:shadow-[0_12px_0_0_#c47f10] active:translate-y-1 active:shadow-[0_4px_0_0_#c47f10] ${sizing} ${className}`} data-id="element-3" data-mp="2tykweepjedqe">
      <span className="text-center leading-tight" data-id="element-4" data-mp="38o90fnp3rqht">{children}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 group-hover:translate-x-1" strokeWidth={3} data-id="element-5" data-mp="38q3ld20djilw" />
    </a>;
}